// extracted by mini-css-extract-plugin
export var label = "_d0-1";
export var reminder = "_d0-0";